import { render, staticRenderFns } from "./management_model.vue?vue&type=template&id=2fc28808"
import script from "./management_model.vue?vue&type=script&lang=js"
export * from "./management_model.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports